const blockedHosts = new Set(["localhost", "127.0.0.1", "0.0.0.0", "::1"]);

export function normalizePublicUrl(input: string) {
  const withProtocol = /^https?:\/\//i.test(input.trim())
    ? input.trim()
    : `https://${input.trim()}`;
  const url = new URL(withProtocol);

  if (!['http:', 'https:'].includes(url.protocol)) {
    throw new Error("Seules les URL HTTP et HTTPS sont acceptées.");
  }

  const hostname = url.hostname.toLowerCase();
  if (
    blockedHosts.has(hostname) ||
    hostname.endsWith(".local") ||
    /^10\./.test(hostname) ||
    /^192\.168\./.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(hostname)
  ) {
    throw new Error("Cette adresse n’est pas un site public.");
  }

  return url.toString();
}

/**
 * Adresse saisie par un visiteur (« votre-site.fr », « https://… ») : l'URL
 * publique normalisée, ou null si ce n'est manifestement pas un site.
 * Utilisable côté client comme côté serveur.
 */
export function parseSiteUrl(input: string) {
  const value = input.trim();
  if (!value || value.length > 300 || /\s/.test(value)) return null;
  try {
    const url = normalizePublicUrl(value);
    const { hostname } = new URL(url);
    return /^[^.]+(\.[^.]+)+$/.test(hostname) && !hostname.endsWith(".") ? url : null;
  } catch {
    return null;
  }
}

/** Nom de domaine lisible d'une URL normalisée : « acme.fr ». */
export function siteLabel(url: string) {
  return new URL(url).hostname.replace(/^www\./, "");
}
